module.exports = __webpack_public_path__ + "static/media/SPC_03.3caf9bd1.jpeg";